import {FC, useEffect} from 'react'

import {Spinner} from '@/components/Spinner'
import {theme} from '@/theme/theme'
import {getFileImageSrc} from '@/utils/document/helpers'
import {DocumentLocation} from '@/utils/document/types'
import {useFileFetch} from '@/utils/user-portal/hooks'

type TrademarkImageProps = {
  logoDocument: DocumentLocation
  isCentered?: boolean
  maxHeight?: string
}

export const TrademarkImage: FC<React.PropsWithChildren<TrademarkImageProps>> = ({
  logoDocument,
  isCentered = true,
  maxHeight = 'inherit',
}) => {
  const {blob, isLoading, downloadAction, filename} = useFileFetch()

  useEffect(() => {
    if (logoDocument) {
      downloadAction(logoDocument)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logoDocument.hubId, logoDocument.id])

  const logoSrc = blob && filename ? getFileImageSrc(blob, filename) : undefined

  return (
    <>
      {isLoading ? (
        <div className="spinner-wrapper">
          <Spinner color={theme.palette.text.default} />
        </div>
      ) : logoSrc ? (
        <img src={logoSrc} alt="Trademark logo" className="tm-logo" />
      ) : null}

      <style jsx>{`
        .spinner-wrapper {
          display: flex;
          align-items: center;
          justify-content: ${isCentered ? 'center' : 'flex-start'};
          width: 100%;
          height: 100%;
        }
        .tm-logo {
          width: 100%;
          height: 100%;
          object-fit: contain;
          object-position: ${isCentered ? 'center' : 'left'};
          max-height: ${maxHeight};
        }
      `}</style>
    </>
  )
}
